import {ChangeDetectionStrategy, Component, inject, input, output, signal} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {addCooperationOfferFormFields} from "../../configs/add-cooperation-offer-config";
import {AddCooperationOfferService} from "../../services/add-cooperation-offer.service";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {MatButton} from "@angular/material/button";
import {MatStepperNext} from "@angular/material/stepper";
import {CloseModalReason} from "../../../../../types/modal.types";

@Component({
  selector: 'app-form-cooperation-offer',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatButton,
    MatStepperNext
  ],
  templateUrl: './form-cooperation-offer.component.html',
  styleUrls: [
    './form-cooperation-offer.component.scss',
    '../../add-cooperation-offer.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormCooperationOfferComponent {
  formGroup = input<FormGroup>(new FormGroup({}));
  currentStep = input<number>(0);
  nextStep = output<void>();
  handleClose = output<CloseModalReason>();

  private addCooperationOfferService: AddCooperationOfferService = inject(AddCooperationOfferService);

  public readonly addCooperationOfferFormFields = addCooperationOfferFormFields;
  private url = signal<string | null>(null);
  private hasAtSymbol  = signal<boolean>(false);

  public onInputChange(event: Event, key: string): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    key === 'channelUrl' && this.handleUrlChange(value);
    (key === 'channelName' && this.url()) && this.handleNameChange(value);
    !value && this.handleEmptyInput(key);
  }

  public nextStepClick() {
    this.nextStep.emit();
  }

  public getNameButtonClose(step: number): string {
    return step === 2 ? 'Закрыть' : 'Отмена';
  }

  private handleUrlChange(value: string): void {
    const { username, rawUsername } = this.addCooperationOfferService.extractUsername(value);
    this.formGroup().get('channelName' as string)?.setValue(username);
    this.url.set(value ? this.addCooperationOfferService.extractUrl(value, rawUsername) : null);
    this.hasAtSymbol.set((value && rawUsername) ? rawUsername.startsWith('@') : false);
  }

  private handleNameChange(value: string): void {
    const prefix = this.hasAtSymbol() ? '@' : '';
    const newUrl = value ? `${this.url}${prefix}${value}` : '';
    this.formGroup().get('channelUrl' as string)?.setValue(newUrl);
  }

  private handleEmptyInput(key: string): void {
    this.formGroup().get(key)?.setValue('');
    this.url.set(null);
    this.hasAtSymbol.set(false);
  }
}
